import { Link, Button } from '@chakra-ui/react'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query SupportLoginQuery(
    $id: Int!
    $personId: Int
    $site: JSON
    $returnTo: Boolean
    $three: Boolean
  ) {
    school(id: $id) {
      id
      name: schoolName
      supportLoginUrl(
        personId: $personId
        site: $site
        returnTo: $returnTo
        three: $three
      )
    }
  }
`
export const beforeQuery = (props) => {
  return {
    variables: {
      ...props,
      id: Number(props.id),
      personId:
        props.personId === null || props.personId === undefined
          ? props.personId
          : Number(props.personId),
      site: props.site || {},
      returnTo: props.returnTo || false,
    },
    fetchPolicy: 'network-only',
  }
}
export const Loading = ({ name, from, label }) => {
  let loading = '\u25cc'
  if (from === 'schoolCell' || from === 'schoolSitesCell') {
    return loginButton(loading, label)
  }

  return (
    <Link
      href="#!"
      color="teal.500"
      onClick={(e) => {
        e.preventDefault()
      }}
    >
      {name} {loading}
    </Link>
  )
}

export const Empty = () => <div>Empty</div>

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ school, from, label }) => {
  const fromSchoolSitesCell = from === 'schoolSitesCell'
  const fromSchoolCell = from === 'schoolCell'

  const checkMark = '\u2713'
  const cross = '\u2716'

  if (school.supportLoginUrl) {
    if (fromSchoolCell || fromSchoolSitesCell) {
      window.open(school.supportLoginUrl, '_blank')

      return loginButton(checkMark, label)
    }
    return loginLink(school)
  }
  return fromSchoolCell ? loginButton(cross) : school.name
}

const loginButton = (icon, label = 'Log in') => {
  return (
    <Button
      colorScheme="teal"
      marginTop={4}
      marginRight={2}
      onClick={(e) => {
        e.preventDefault()
      }}
      variant="outline"
    >
      {label} {icon}
    </Button>
  )
}

const loginLink = (school) => {
  return (
    <Link
      href={school.supportLoginUrl}
      isExternal
      color="teal.500"
      style={{ textDecoration: 'none' }}
    >
      {school.name} &#x2197;
    </Link>
  )
}
